$(document).ready(function(){
  // Show the first tab and hide the rest
$('#tabs-nav li:first-child').addClass('active');
$('.tab-content').hide();
$('.tab-content:first').show();

// Click function
$('#tabs-nav li').click(function(){
  $('#tabs-nav li').removeClass('active');
  $(this).addClass('active');
  $('.tab-content').hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).fadeIn();
  return false;
});

  $(".question").click(function(){
    var $this = $(this); // Current question element
    var $answer = $this.next('.answer'); // Corresponding answer element
    
    // Toggle the active class on the clicked question
    $this.toggleClass('active');
    
    // Slide toggle the corresponding answer
    $answer.slideToggle();
    
    // Close other open answers and remove their active class
    $('.question').not($this).removeClass('active');
    $('.answer').not($answer).slideUp();
});
})

  const ua = navigator.userAgent;

  // Detect macOS
  if (ua.includes('Macintosh')) {
    document.documentElement.classList.add('mac');
  }

  // Detect iOS devices
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
    document.documentElement.classList.add('mac');
  }




